import { Modal } from "antd";
import { LockOutlined } from "@ant-design/icons";

// Small, centered, responsive modal used wherever a plan-gated feature is tapped/clicked
// instead of a disabled button + title tooltip, which gives no feedback on touch devices.
export const showFeatureNotIncludedModal = (message, title, okText) => {
  Modal.info({
    icon: <LockOutlined />,
    title,
    content: message,
    okText,
    centered: true,
    maskClosable: true,
  });
};
